
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */
import {Component, Vue} from "vue-property-decorator";

@Component
export default class LwContainer extends Vue {
  $refs: {
    cHeader?: HTMLFormElement | null,
    cMain?: HTMLFormElement | null,
    cFooter?: HTMLFormElement | null,
  }

  mounted(): void {
    // let {header, main, footer} = this.$slots;
    // let height = window.innerHeight
    // let cHeaderHeight = 0, cMainHeight = 0, cFooterHeight = 0;
    // if (header) {
    //     cHeaderHeight = this.$refs.cHeader.offsetHeight;
    // }
    //
    // if (footer) {
    //     cFooterHeight = this.$refs.cFooter.offsetHeight;
    // }
    // let tMinHeight = height - cHeaderHeight - cFooterHeight;
    //
    // if (main) {
    //     // cMainHeight = this.$refs.cMain.offsetHeight;
    //     this.$refs.cMain.style.minHeight = tMinHeight + 'px';
    // }
    // console.log(height, cHeaderHeight, cMainHeight, cFooterHeight, tMinHeight)
  }
}
